import { axiosInstanceV2 } from './AxiosInstance';
const API_URL = '/roles';

export const getRoles = async (paramsOrLimit = 10, page = 1, search = '', includeTotal = true) => {
  try {
    const params =
      typeof paramsOrLimit === 'object' && paramsOrLimit !== null
        ? { limit: 10, page: 1, search: '', includeTotal: true, searchField: 'name', ...paramsOrLimit }
        : { limit: paramsOrLimit, page, search, includeTotal, searchField: 'name' };

    const response = await axiosInstanceV2.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching list roles', error);
    throw error;
  }
};

export const getRole = async (id) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles', error);
    throw error;
  }
};

export const addRole = async (roleData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, roleData);
    return response.data;
  } catch (error) {
    console.error('Error adding role', error);
    throw error;
  }
};

export const updateRole = async (roleId, role) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${roleId}`, role);
    return response.data;
  } catch (error) {
    console.error('Error updating role', error);
    throw error;
  }
};

export const deleteRole = async (roleId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${roleId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting role', error);
    throw error;
  }
};
